module.exports = __webpack_public_path__ + "static/media/singleMonPosTerminal.2b8cc8ca.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/pricing/singleMonPosTerminal.png
 ** module id = 653
 ** module chunks = 0
 **/